import { GenIcon } from '../helpers/IconBase.es.js';

const ArrowLeftFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M15 16.4767L15 7.52331C15 7.07668 14.4733 6.83609 14.133 7.12731L9.36523 11.208C8.87826 11.6248 8.87826 12.3752 9.36523 12.792L14.133 16.8727C14.4733 17.1639 15 16.9233 15 16.4767Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { ArrowLeftFilled };
